import { defineComponent } from 'vue';
import { getAppService } from 'src/services/index';
import useRouterService from './services/router.service';
export default defineComponent({
    name: 'App',
    setup() {
        // console.log('DEBUG: start of APP.vue init')
        // INITIALIZE APP
        const { instanceNr } = useRouterService();
        const { initialize } = getAppService();
        initialize();
        // console.log('DEBUG: end of APP.vue init')
        return { instanceNr };
    },
});
